import { lazy, Suspense, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { SiteProvider } from "./lib/site";
import { AuthProvider } from "./lib/auth";
import { captureUtm } from "./lib/api";
import Layout from "./components/site/Layout";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Senior from "./pages/Senior";
import Quote from "./pages/Quote";
import QuoteView from "./pages/QuoteView";
import { About, BeforeAfter, Contact, Privacy, Terms, Review, NotFound } from "./pages/Info";
import CityPage, { ServiceAreas } from "./pages/CityPage";

const Owner = lazy(() => import("./pages/owner/OwnerApp"));
const PubEst = lazy(() => import("./pages/admin/Docs").then((m) => ({ default: m.PublicEstimate })));
const PubInv = lazy(() => import("./pages/admin/Docs").then((m) => ({ default: m.PublicInvoice })));

function App() {
  useEffect(() => {
    captureUtm();
  }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <SiteProvider>
          <Routes>
            <Route path="/owner/*" element={<Navigate to="/admin" replace />} />
            <Route path="/admin/*" element={<AuthProvider><Suspense fallback={<p className="p-10">Loading…</p>}><Owner /></Suspense></AuthProvider>} />
            <Route element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="services" element={<Services />} />
              <Route path="senior-home-support" element={<Senior />} />
              <Route path="about" element={<About />} />
              <Route path="before-and-after" element={<BeforeAfter />} />
              <Route path="service-areas" element={<ServiceAreas />} />
              <Route path="service-areas/:city" element={<CityPage />} />
              <Route path="quote" element={<Quote />} />
              <Route path="contact" element={<Contact />} />
              <Route path="privacy" element={<Privacy />} />
              <Route path="terms" element={<Terms />} />
              <Route path="review" element={<Review />} />
              <Route path="q/:token" element={<QuoteView />} />
              <Route path="e/:token" element={<Suspense fallback={null}><PubEst /></Suspense>} />
              <Route path="i/:token" element={<Suspense fallback={null}><PubInv /></Suspense>} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
          <Toaster richColors position="top-center" />
        </SiteProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
